const TRUCK = require('./lib/truck');
const LEVEL = require('./lib/level');
const pando3D = require('./lib/setup');

module.exports = {
  TRUCK,
  pando3D,
  LEVEL,
};
